import { render, staticRenderFns } from "./V2Table.vue?vue&type=template&id=40dc134c&scoped=true&"
import script from "./V2Table.vue?vue&type=script&lang=js&"
export * from "./V2Table.vue?vue&type=script&lang=js&"
import style0 from "./V2Table.vue?vue&type=style&index=0&id=40dc134c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dc134c",
  null
  
)

export default component.exports